import WebIM from "@/utils/WebIM";

const Login = {
    state: {
        isRegister: false,
        username: "",
    },
    mutations: {},
    actions: {
        onLogin: function(context, payload) {
            context.commit("setUserName", payload.username);
            // let options = {
            //     apiUrl: WebIM.config.apiURL,
            //     user: payload.username,
            //     accessToken: payload.accessToken,
            //     appKey: WebIM.config.appkey,
            // };
            // WebIM.conn.open(options);
            localStorage.setItem("userInfo",
                JSON.stringify({
                    userId: payload.username,
                    accessToken: payload.accessToken,
                    nickName: payload.nickName,
                    headImg: payload.headImg,
                }));
        },
        onLogout: function() {
            const userInfo = localStorage.getItem("userInfo");
            localStorage.setItem("userInfo", "");
            if ( window.WebIM && window.WebIM.conn && userInfo ) {
                const conn = window.WebIM.conn;
                if ( conn.close && typeof conn.close === "function" ) {
                    console.log("退出登录");
                    conn.close();
                }
            }
        },
    },
    getters: {},
};
export default Login;



// WEBPACK FOOTER //
// ./src/store/login.js